module.exports = __webpack_public_path__ + "static/media/temporaria.5c2378b3.png";